import { render, staticRenderFns } from "./document-upload.vue?vue&type=template&id=10f4a973&"
import script from "./document-upload.vue?vue&type=script&lang=js&"
export * from "./document-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f4a973')) {
      api.createRecord('10f4a973', component.options)
    } else {
      api.reload('10f4a973', component.options)
    }
    module.hot.accept("./document-upload.vue?vue&type=template&id=10f4a973&", function () {
      api.rerender('10f4a973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-upload.vue"
export default component.exports